import { Alert, AlertTitle, Stack, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'
import { useGetAlertsQuery } from 'src/_api/alertApi'

export default function Alerts() {
    const theme = useTheme()

    const { data, isLoading } = useGetAlertsQuery()
    const [alerts, setAlerts] = useState([])

    useEffect(() => {
        if (data) {
            setAlerts(data || [])
        }
    }, [data])

    const closeAlertHandler = (id) => {
        setAlerts((prevAlerts) => prevAlerts.filter(alert => alert.id !== id))
    }

    return (
        <Stack gap={1} sx={{ mb: 1 }}>
            {
                alerts?.map((alert) => (
                    <Alert
                        key={alert.id}
                        variant="filled"
                        severity={alert.type.toLowerCase()}
                        sx={{ bgcolor: alert.type === "WARNING" ? "#ffbc0d" : undefined, mx: 1 }}
                        onClose={() => closeAlertHandler(alert.id)}
                    >
                        {
                            (!!alert?.title_ar || !!alert?.title_ar) &&
                            <AlertTitle>{theme?.direction === "rtl" ? alert.title_ar : alert.title_en}</AlertTitle>
                        }
                        {theme?.direction === "rtl" ? alert.message_ar : alert.message_en}
                    </Alert>
                ))
            }
        </Stack>
    )
}
